import type { UserAccountDetails } from "@/types/account";

// key and name should match
export const gtmDynamicEvents = {
  analytics_custom_event: "analytics_custom_event",
} as const;

export type GtmDynamicEventName = keyof typeof gtmDynamicEvents;

export const analyticsEvents = {
  MILESTONES: {
    // will mostly be managed on GTM dashboard
    checkout_success: "Checkout success",
  },
  GENERAL: {
    ad_traffic_auth_complete: "Ad traffic user authenticated",
  },
  ONBOARDING: {
    start_onboarding: "Start onboarding",
    skip_onboarding: "Skip onboarding",
    continue_onboarding_immediately: "Continue onboarding immediately",
    resuming_onboarding: "Resuming onboarding",
    save_step: "Save onboarding step",
  },
  QUICK_TASK: {
    quick_task_keyboard_open: "Open quick task with shortcut",
    quick_task_keyboard_close: "Close quick task with shortcut",
    quick_task_submit_prompt: "Submit quick task prompt",
    quick_task_cancel_prompt: "Cancel quick task prompt",
    quick_task_return_after_posting: "Quick task return after posting",
    quick_task_another_task_after_posting: "Quick task start new task after posting",
    quick_task_select_task_type: "Quick task select task type",
    quick_task_select_category: "Quick task select category",
    quick_task_clear_category: "Quick task clear category",
    quick_task_clear_task_type: "Quick task clear task type",
    quick_task_select_recent: "Quick task select recent task type",
    quick_task_result_action_edit: "Open quick task result edit view",
    quick_task_action_add_media: "Open quick task result add media dialog",
    quick_task_action_regenerate: "Open quick task result regenerate dialog",
    quick_task_schedule_post: "Start quick task result schedule flow",
    quick_task_post_now: "Start quick task result posting flow",
    quick_task_close_image_picker: "Close image picker in quick task prompt",
    quick_task_dialog_closed: "Quick task dialog closed",
    quick_task_dialog_opened: "Quick task dialog opened",
    quick_task_form_open_media_library: "Open media library in quick task prompt",
  },
  TASKS: {
    task_form_open_media_library: "Open media library in task task prompt",
    task_close_image_picker: "Close image picker in task prompt",
    select_task_type: "Select task type",
    submit_prompt: "Submit task prompt",
  },
};

export function sendDynamicGtmAnalyticsEvent(
  analyticsEventName: string,
  gtmEvent: GtmDynamicEventName = gtmDynamicEvents.analytics_custom_event
) {
  if (typeof window === "undefined" || !("dataLayer" in window)) {
    console.warn("GTM dataLayer is not available.");
  } else {
    window.dataLayer?.push({
      event: gtmEvent,
      analytics_event_name: analyticsEventName,
    });
  }
}

export function identifyAnalyticsSession(user: UserAccountDetails) {
  // change when analytics tool changes
  if ("clarity" in window && typeof window.clarity === "function") {
    return window.clarity(
      "identify",
      user.activeAccountId,
      undefined,
      undefined,
      user.companyName
    );
  }
}

export type AnalyticsEventName =
  | keyof typeof analyticsEvents.GENERAL
  | keyof typeof analyticsEvents.ONBOARDING
  | keyof typeof analyticsEvents.QUICK_TASK
  | keyof typeof analyticsEvents.TASKS
  | keyof typeof analyticsEvents.MILESTONES;
